import React from "react";
import { Link } from "react-router-dom";
import { Plane } from "lucide-react";

const COLS = [
  {
    title: "Product",
    links: [
      { label: "Features", href: "/#features" },
      { label: "How it works", href: "/#how" },
      { label: "Pricing", href: "/#pricing" },
      { label: "Guarantee", href: "/#guarantee" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "/about" },
      { label: "Contact", href: "/contact" },
      { label: "FAQ", href: "/#faq" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms", href: "/terms" },
      { label: "Refund Policy", href: "/refund-policy" },
      { label: "Success Guarantee", href: "/success-guarantee" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="bg-[#050505] text-white border-t border-white/10" data-testid="footer">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-8 w-8 rounded-lg bg-gradient-to-br from-amber-400 to-red-600 flex items-center justify-center">
                <Plane className="h-4 w-4 text-white -rotate-45" />
              </div>
              <span className="font-display text-lg font-bold">sarkarijobai</span>
            </div>
            <p className="text-sm text-white/50 max-w-xs leading-relaxed">
              An AI exam success platform for serious Indian competitive-exam aspirants. Stop studying
              randomly. Start preparing with a system.
            </p>
            <p className="text-xs text-white/30 mt-6">
              sarkarijobai does not guarantee admission, rank, government employment or selection. Refund
              guarantee applies only under published eligibility and qualifying-outcome terms.
            </p>
          </div>

          {COLS.map((c) => (
            <div key={c.title}>
              <h5 className="font-display text-sm font-semibold mb-4 text-white/80">{c.title}</h5>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.href} className="text-sm text-white/50 hover:text-amber-300 transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} sarkarijobai. All rights reserved.</p>
          <p className="text-xs text-white/40">AI-powered · Personalized · Exam-focused</p>
        </div>
      </div>
    </footer>
  );
};
